"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapTravelDatesModalToTrackableTravelDates = exports.mapSearchControlTravelPeriodToFormTravelDates = exports.mapFlexibleTravelPeriodToFormTravelDate = exports.mapExactTravelPeriodToFormTravelDates = exports.mapFlexibleTravelPeriodToIDurationValue = exports.mapExactTravelPeriodToIDurationValue = exports.mergeFdrTravelDatesState = exports.adjustFdrTravelDates = exports.getReturnDate = exports.calculateReturnDate = exports.calculateDateRange = exports.getDurationValuesBySearchType = exports.getDurationSearchPeriod = exports.FLEXIBLE_DURATION_VALUES = exports.EXACT_DURATION_VALUES = void 0;
const format_1 = __importDefault(require("date-fns/format"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const libs_utils_1 = require("@hotelplan/libs.utils");
const fdr_travel_dates_utils_1 = require("./fdr-travel-dates.utils");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
exports.EXACT_DURATION_VALUES = [
    { duration: [1], type: 'week' },
    { duration: [2], type: 'week' },
    { duration: [1], type: 'night' },
    { duration: [2], type: 'night' },
    { duration: [3], type: 'night' },
    { duration: [4], type: 'night' },
    { duration: [5], type: 'night' },
    { duration: [6], type: 'night' },
    { duration: [7], type: 'night' },
    { duration: [8], type: 'night' },
    { duration: [9], type: 'night' },
    { duration: [10], type: 'night' },
    { duration: [11], type: 'night' },
    { duration: [12], type: 'night' },
    { duration: [13], type: 'night' },
    { duration: [14], type: 'night' },
];
exports.FLEXIBLE_DURATION_VALUES = [
    ...exports.EXACT_DURATION_VALUES,
    { duration: (0, fdr_travel_dates_utils_1.expandRange)([1, 8]), type: 'night' },
    { duration: (0, fdr_travel_dates_utils_1.expandRange)([1, 3]), type: 'night' },
    { duration: (0, fdr_travel_dates_utils_1.expandRange)([4, 5]), type: 'night' },
    { duration: (0, fdr_travel_dates_utils_1.expandRange)([6, 8]), type: 'night' },
    { duration: (0, fdr_travel_dates_utils_1.expandRange)([7, 10]), type: 'night' },
    { duration: (0, fdr_travel_dates_utils_1.expandRange)([9, 15]), type: 'night' },
    { duration: (0, fdr_travel_dates_utils_1.expandRange)([16, 22]), type: 'night' },
];
const DATE_INPUT_FORMAT = 'yyyy-MM-dd';
const DEFAULT_EXACT_DURATION_IN_DAYS = 7;
function getDurationSearchPeriod(duration) {
    return duration.duration.length >= 2
        ? supergraph_api_1.FdrTravelPeriodType.Flexible
        : supergraph_api_1.FdrTravelPeriodType.Exact;
}
exports.getDurationSearchPeriod = getDurationSearchPeriod;
function getDurationValuesBySearchType(searchType, customFlexibleDurationValues) {
    const flexibleDurationValues = customFlexibleDurationValues
        ? customFlexibleDurationValues
        : exports.FLEXIBLE_DURATION_VALUES;
    return searchType === supergraph_api_1.FdrTravelPeriodType.Flexible
        ? flexibleDurationValues
        : exports.EXACT_DURATION_VALUES;
}
exports.getDurationValuesBySearchType = getDurationValuesBySearchType;
function calculateDateRange(endDate, startDate) {
    return (0, libs_utils_1.differenceInCalendarDays)(endDate, startDate);
}
exports.calculateDateRange = calculateDateRange;
function calculateReturnDate(departureDate, durationInDays) {
    return (0, libs_utils_1.addDays)(departureDate, durationInDays);
}
exports.calculateReturnDate = calculateReturnDate;
function getReturnDate(departureDate, returnDate, duration) {
    if (returnDate) {
        return (0, format_1.default)(returnDate, DATE_INPUT_FORMAT);
    }
    if (!departureDate)
        return null;
    if (!duration) {
        return (0, format_1.default)(calculateReturnDate(departureDate, DEFAULT_EXACT_DURATION_IN_DAYS), DATE_INPUT_FORMAT);
    }
    if (duration) {
        const maxDuration = (0, fdr_travel_dates_utils_1.getMaxDurationInDays)(duration);
        return (0, format_1.default)(calculateReturnDate(departureDate, maxDuration), DATE_INPUT_FORMAT);
    }
    return null;
}
exports.getReturnDate = getReturnDate;
function adjustFdrTravelDates(travelDatesState) {
    if (!travelDatesState)
        return null;
    const travelDatesResult = (0, cloneDeep_1.default)(travelDatesState);
    const { defaults, searchType } = travelDatesResult;
    const startOfToday = (0, libs_utils_1.getTodaysDate)();
    const departureStartDay = (0, libs_utils_1.startOfDay)(travelDatesResult.departureDate);
    const returnStartDay = travelDatesResult.returnDate
        ? (0, libs_utils_1.startOfDay)(travelDatesResult.returnDate)
        : null;
    const departureInPast = (0, libs_utils_1.isBefore)(departureStartDay, startOfToday) ||
        (0, libs_utils_1.isEqual)(departureStartDay, startOfToday);
    const returnInPast = returnStartDay
        ? (0, libs_utils_1.isBefore)(returnStartDay, startOfToday) ||
            (0, libs_utils_1.isEqual)(returnStartDay, startOfToday)
        : false;
    if (departureInPast && returnInPast) {
        if (defaults && searchType === supergraph_api_1.FdrTravelPeriodType.Flexible) {
            travelDatesResult.departureDate = defaults.flexible.departureDate;
            travelDatesResult.returnDate = defaults.flexible.returnDate;
        }
        if (defaults && searchType === supergraph_api_1.FdrTravelPeriodType.Exact) {
            travelDatesResult.departureDate = defaults.exact.departureDate;
            travelDatesResult.returnDate = defaults.exact.returnDate;
        }
    }
    else if (departureInPast) {
        // If departure date in the past, set today + 1
        travelDatesResult.departureDate = (0, libs_utils_1.addDays)(startOfToday, 1);
        if (returnStartDay && searchType === supergraph_api_1.FdrTravelPeriodType.Flexible) {
            const diffDays = Math.abs((0, libs_utils_1.differenceInCalendarDays)(travelDatesResult.departureDate, returnStartDay));
            const currDuration = travelDatesResult.duration.duration[0];
            if (diffDays < currDuration) {
                travelDatesResult.returnDate = (0, libs_utils_1.addDays)(travelDatesResult.departureDate, currDuration);
            }
        }
    }
    return travelDatesResult;
}
exports.adjustFdrTravelDates = adjustFdrTravelDates;
function mergeFdrTravelDatesState(travelDatesState, globalTravelDates) {
    if (!travelDatesState)
        return null;
    let travelDates = travelDatesState;
    if (globalTravelDates) {
        travelDates = Object.assign(Object.assign({}, globalTravelDates), { defaults: travelDatesState.defaults });
    }
    return adjustFdrTravelDates(travelDates);
}
exports.mergeFdrTravelDatesState = mergeFdrTravelDatesState;
// TODO: commented mappers below make sense to refactor while working on search-control
// export const mapTravelDatesModelToTravelPeriodCriteria = (
//   travelDates?: IFdrTravelDatesState | null
// ): TravelPeriodCriteriaInput => {
//   const searchPeriodType = travelDates
//     ? travelDates.searchType
//     : FdrTravelPeriodType.Exact;
//   const returnDate = getReturnDate(
//     travelDates?.departureDate,
//     travelDates?.returnDate,
//     travelDates?.duration
//   );
//
//   return {
//     departureDate: travelDates
//       ? format(travelDates.departureDate, DATE_INPUT_FORMAT)
//       : null,
//     returnDate,
//     maxDuration: travelDates
//       ? getMaxDurationInDays(travelDates.duration)
//       : null,
//     minDuration: travelDates
//       ? getMinDurationInDays(travelDates.duration)
//       : null,
//     searchPeriodType,
//   };
// };
// export const mapTravelDatesStateToExactTravelPeriodInput = (
//   travelDates: IFdrTravelDatesState | null | undefined
// ): ExactTravelPeriodInput => {
//   const returnDate = getReturnDate(
//     travelDates?.departureDate,
//     travelDates?.returnDate,
//     travelDates?.duration
//   );
//
//   return {
//     departureDate: travelDates
//       ? format(travelDates.departureDate, DATE_INPUT_FORMAT)
//       : '',
//     returnDate: returnDate || '',
//   };
// };
// export const mapSearchControlExactTravelPeriodToExactTravelPeriodInput = (
//   travelPeriod: ExactTravelPeriodInput | null | undefined
// ): ExactTravelPeriodInput => {
//   return {
//     returnDate: travelPeriod?.returnDate || '',
//     departureDate: travelPeriod?.departureDate || '',
//   };
// };
const mapExactTravelPeriodToIDurationValue = (exactDepartureDate, exactReturnDate) => {
    return {
        duration: (0, fdr_travel_dates_utils_1.expandRange)([
            calculateDateRange(exactReturnDate, exactDepartureDate),
        ]),
        type: 'night',
    };
};
exports.mapExactTravelPeriodToIDurationValue = mapExactTravelPeriodToIDurationValue;
function mapFlexibleTravelPeriodToIDurationValue(flexibleDurations) {
    const minDuration = flexibleDurations[0];
    const maxDuration = flexibleDurations[flexibleDurations.length - 1];
    return {
        type: 'night',
        duration: minDuration === maxDuration
            ? [minDuration]
            : (0, fdr_travel_dates_utils_1.expandRange)([minDuration, maxDuration]),
    };
}
exports.mapFlexibleTravelPeriodToIDurationValue = mapFlexibleTravelPeriodToIDurationValue;
const mapExactTravelPeriodToFormTravelDates = (exactDepartureDate, exactReturnDate) => {
    const departureDate = (0, libs_utils_1.parseDateStr)(exactDepartureDate);
    const returnDate = exactReturnDate ? (0, libs_utils_1.parseDateStr)(exactReturnDate) : null;
    const duration = (0, exports.mapExactTravelPeriodToIDurationValue)(departureDate, returnDate);
    const extraDurations = (0, fdr_travel_dates_utils_1.containsDurationValue)(duration, exports.FLEXIBLE_DURATION_VALUES)
        ? []
        : [duration];
    return {
        departureDate,
        returnDate,
        duration,
        extraDurations,
        searchType: supergraph_api_1.FdrTravelPeriodType.Exact,
    };
};
exports.mapExactTravelPeriodToFormTravelDates = mapExactTravelPeriodToFormTravelDates;
const mapFlexibleTravelPeriodToFormTravelDate = (flexibleDepartureDate, flexibleReturnDate, flexibleDurations) => {
    const departureDate = (0, libs_utils_1.parseDateStr)(flexibleDepartureDate);
    const returnDate = flexibleReturnDate
        ? (0, libs_utils_1.parseDateStr)(flexibleReturnDate)
        : null;
    const duration = mapFlexibleTravelPeriodToIDurationValue(flexibleDurations);
    const extraDurations = (0, fdr_travel_dates_utils_1.containsDurationValue)(duration, exports.FLEXIBLE_DURATION_VALUES)
        ? []
        : [duration];
    return {
        departureDate,
        returnDate,
        duration,
        extraDurations,
        searchType: supergraph_api_1.FdrTravelPeriodType.Flexible,
    };
};
exports.mapFlexibleTravelPeriodToFormTravelDate = mapFlexibleTravelPeriodToFormTravelDate;
const mapSearchControlTravelPeriodToFormTravelDates = (travelPeriodComponent) => {
    const exactTravelDates = (0, exports.mapExactTravelPeriodToFormTravelDates)(travelPeriodComponent.exactDepartureDate, travelPeriodComponent.exactReturnDate);
    const flexibleTravelDates = (0, exports.mapFlexibleTravelPeriodToFormTravelDate)(travelPeriodComponent.flexibleDepartureDate, travelPeriodComponent.flexibleReturnDate, travelPeriodComponent.flexibleDurations);
    if (travelPeriodComponent.defaultPeriod === supergraph_api_1.FdrTravelPeriodType.Exact) {
        return Object.assign(Object.assign({}, exactTravelDates), { defaults: { exact: exactTravelDates, flexible: flexibleTravelDates } });
    }
    return Object.assign(Object.assign({}, flexibleTravelDates), { defaults: { exact: exactTravelDates, flexible: flexibleTravelDates } });
};
exports.mapSearchControlTravelPeriodToFormTravelDates = mapSearchControlTravelPeriodToFormTravelDates;
// export function calculateMinMaxTravelPeriod(
//   travelPeriodComponent: TravelPeriodComponent | undefined
// ) {
//   let minDuration: number | null = null;
//   let maxDuration: number | null = null;
//
//   if (travelPeriodComponent?.type === FdrTravelPeriodType.Flexible) {
//     minDuration = travelPeriodComponent.flexiblePeriod.minDuration;
//     maxDuration = travelPeriodComponent.flexiblePeriod.maxDuration;
//   }
//
//   if (travelPeriodComponent?.type === FdrTravelPeriodType.Exact) {
//     const { departureDate, returnDate } = travelPeriodComponent.exactPeriod;
//     const duration =
//       departureDate && returnDate
//         ? calculateDateRange(
//             parseDateStr(returnDate),
//             parseDateStr(departureDate)
//           )
//         : null;
//     minDuration = duration;
//     maxDuration = duration;
//   }
//
//   return [minDuration, maxDuration] as const;
// }
// export const mapSearchControlTravelPeriodToSearchCriteriaTravelPeriod = (
//   travelPeriodComponent: TravelPeriodComponent | undefined
// ): TravelPeriodCriteriaInput => {
//   const [minDuration, maxDuration] = calculateMinMaxTravelPeriod(
//     travelPeriodComponent
//   );
//   const travelPeriod =
//     travelPeriodComponent?.type === FdrTravelPeriodType.Exact
//       ? travelPeriodComponent.exactPeriod
//       : travelPeriodComponent?.flexiblePeriod;
//   return {
//     minDuration,
//     maxDuration,
//     departureDate: travelPeriod?.departureDate,
//     returnDate: travelPeriod?.returnDate,
//     searchPeriodType:
//       travelPeriodComponent?.type || FdrTravelPeriodType.Flexible,
//   };
// };
const mapTravelDatesModalToTrackableTravelDates = (state) => {
    var _a;
    return {
        duration: (_a = state.duration) === null || _a === void 0 ? void 0 : _a.duration.join('-'),
        exact: state.searchType === supergraph_api_1.FdrTravelPeriodType.Exact,
        from: state.departureDate,
        to: state.returnDate,
    };
};
exports.mapTravelDatesModalToTrackableTravelDates = mapTravelDatesModalToTrackableTravelDates;
//# sourceMappingURL=fdr-travel-dates.mappers.js.map